<!-- Dashboard select -->
<div class='dashboard-select' fxLayout fxLayoutAlign='space-between center'>
  <mat-form-field>
    <mat-label>Select Dashboard</mat-label>
    <mat-select [(value)]='selectedDashboard'
                (closed)="dashboardsSearchControl.setValue('')" (selectionChange)="onDashboardChange($event)">
      <div class="field-container">
        <mat-form-field>
          <mat-label>{{'SEARCH' | translate}}</mat-label>
          <input matInput [formControl]="dashboardsSearchControl">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <!-- Regular dashboards (no meeting level) -->
      <mat-option *ngFor='let dashboard of dashboardsOnSearch || dashboards' class="table-dashboard-select-option" [value]='dashboard'>
        {{ dashboard.title }}
      </mat-option>

      <!-- Level 1 dashboards -->
      <div *ngIf="lvl1dashboards?.length > 0" class="dashboard-select-separator"></div>
      <mat-option *ngFor='let dashboard of lvl1dashboardsOnSearch || lvl1dashboards' class="table-dashboard-select-option" [value]='dashboard'>
        {{ dashboard.title }}
      </mat-option>

      <!-- Level 2 dashboards -->
      <div *ngIf="lvl2dashboards?.length > 0" class="dashboard-select-separator"></div>
      <mat-option *ngFor='let dashboard of lvl2dashboardsOnSearch || lvl2dashboards' class="table-dashboard-select-option" [value]='dashboard'>
        {{ dashboard.title }}
      </mat-option>

      <!-- Level 3 dashboards -->
      <div *ngIf="lvl3dashboards?.length > 0" class="dashboard-select-separator"></div>
      <mat-option *ngFor='let dashboard of lvl3dashboardsOnSearch || lvl3dashboards' class="table-dashboard-select-option" [value]='dashboard'>
        {{ dashboard.title }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="members">
    <app-popup-select-complete
      [selected]="dashboardMembers"
      [addAvailable]="false"
      [removeAvailable]="false"
      [largeSpace]="true"
    ></app-popup-select-complete>
  </div>

  <div class='create-btn-and-links-container'>
    <app-standup-links
      *ngIf='!!selectedDashboardSubject.value'
      [links]='selectedDashboardSubject.value'
      [currentDashboard]='selectedDashboard'
    ></app-standup-links>

    <button
      class="action-btn"
      mat-raised-button
      color="accent"
      [matTooltip]="'DASHBOARD_NEW_TASK_DESCRIPTION' | translate"
      matTooltipClass="formatted-tooltip"
      [disabled]="!selectedDashboard?.id"
      (click)="openNewTaskDialog()"
    >
      <mat-icon>add</mat-icon>
      <span>{{'NEW_TASK' | translate}}</span>
    </button>
  </div>
</div>

<div class='dashboard-card' *ngFor='let card of selectedDashboard?.dashboardcardSet.edges'>
  <app-conversion-rates-transregional
    *ngIf="card.node.card.type === 'CONVERSION_RATES_TRANSREGIONAL_MATRIX'"
    [dashboardTitle]="card.node.card.title"
    [card]='card?.node?.card'
    [dashboardItem]='selectedDashboard'
  >
  </app-conversion-rates-transregional>

  <app-conversions-table
    *ngIf="card.node.card.type === 'CONVERSION_RATES_MATRIX'"
    [dashboardTitle]="card.node.card.title"
    [card]='card?.node?.card'
    [dashboardItem]='selectedDashboard'
  >
  </app-conversions-table>

  <app-critical-orders-table
    *ngIf="card.node.card.type === 'CRITICAL_ORDERS_TABLE'"
    [dashboardTitle]="card.node.card.title"
    [card]='card?.node?.card'
    [dashboardItem]='selectedDashboard'
  ></app-critical-orders-table>

  <app-not-aggregated-table
    *ngIf="card.node.card.type === 'CANDIDATE_REFUSAL_TABLE'"
    [cardId]='card.node.card.id'
    [cardTitle]="card.node.card.title"
    [cardDescription]='card.node.card.description'
    [dashboardItem]='selectedDashboard'
    [metricGroupForOtherProblemId]='card.node.metricGroupForOtherProblem?.id'
  ></app-not-aggregated-table>

  <app-aggregated-metrics-table
    *ngIf="card.node.card.type === 'AGGREGATED_METRIC_TABLE'"
    [cardId]='card.node.card.id'
    [cardTitle]="card.node.card.title"
    [cardDescription]='card.node.card.description'
    [dashboardItem]='selectedDashboard'
    [metricGroupForOtherProblemId]='card.node.metricGroupForOtherProblem?.id'
  ></app-aggregated-metrics-table>

  <app-promises-table
    *ngIf="card.node.card.type === 'PROMISES_TO_CLIENT_MATRIX'"
    [dashboardId]="selectedDashboard?.id"
    [dashboardMembers]="dashboardMembers"
    [includeFromChildDashboards]="card.node.card.includeFromChildDashboards"
    [escalationDashboards]="selectedDashboard?.escalateToDashboards"
    [dashboard]="selectedDashboard"
  ></app-promises-table>

  <app-metric-table
    *ngIf="card.node.card.type === 'METRIC_TABLE'"
    [cardId]='card.node.card.id'
    [cardTitle]="card.node.card.title"
    [cardDescription]='card.node.card.description'
    [dashboardItem]='selectedDashboard'
    [escalationDashboard]='selectedDashboard?.escalateTo'
    [escalationDashboards]='selectedDashboard?.escalateToDashboards'
    [metricGroupForOtherProblemId]='card.node.metricGroupForOtherProblem?.id'
    [includeFromChildDashboards]="card.node.card.includeFromChildDashboards"
  ></app-metric-table>

  <app-weekly-barchart-card
    *ngIf="card.node.card.type === 'WEEKLY_BARCHART'"
    [cardId]='card.node.card.id'
    [cardTitle]="card.node.card.title"
    [dashboardItem]='selectedDashboard'
    [barchartGoal]='card.node.barchartGoal'
    [barchartCardId]="card.node.id"
  ></app-weekly-barchart-card>

  <app-overdue-tasks-table
    *ngIf="card.node.card.type === 'OVERDUE_TASK_TABLE'"
    [dashboardId]='selectedDashboard?.id'
    [cardDescription]='card.node.card.description'
    [filterTaskCategoriesKeys]="card.node.card.filterTaskCategoriesKeys"
    [excludeTaskCategoriesKeys]="card.node.card.excludeTaskCategoriesKeys"
    [excludeStatuses]="card.node.card.excludeTaskStatuses"
    #taskOverdueTable
  ></app-overdue-tasks-table>

  <app-meeting-table
    *ngIf="card.node.card.type === 'CLIENT_MEETING_TASKS'"
    [cardTitle]='card.node.card.title'
    [cardDescription]='card.node.card.description'
    [dashboardMembers]='dashboardMembers'
    [dashboardId]='selectedDashboard?.id'
    [filterTaskCategoriesKeys]="card.node.card.filterTaskCategoriesKeys"
    [excludeTaskCategoriesKeys]="card.node.card.excludeTaskCategoriesKeys"
    [excludeStatuses]="card.node.card.excludeTaskStatuses"
    [includeFromChildDashboards]="card.node.card.includeFromChildDashboards"
    #meetingOverdueTable
  ></app-meeting-table>

  <app-dynamic-dashboard-tasks-table
    *ngIf="card.node.card.type === 'DYNAMIC_TASKS_TABLE'"
    [cardTitle]='card.node.card.title'
    [cardDescription]='card.node.card.description'
    [additionalFilters]='card.node.card.additionalFilters'
    [dashboardId]='selectedDashboard?.id'
    [filterTaskCategoriesKeys]="card.node.card.filterTaskCategoriesKeys"
    [excludeTaskCategoriesKeys]="card.node.card.excludeTaskCategoriesKeys"
    [excludeStatuses]="card.node.card.excludeTaskStatuses"
    [displayColumnsJSON]="card.node.card.displayColumns"
    [lookForwardDays]='card.node.card.lookForwardDays'
    [includeFromChildDashboards]="card.node.card.includeFromChildDashboards"
    [dashboardMembers]='dashboardMembers'
  ></app-dynamic-dashboard-tasks-table>

  <app-resources-lvl2-table
    *ngIf="card?.node?.card?.type === 'REGION_HOURS_MATRIX' && selectedDashboard?.id"
    [card]='card?.node?.card'
    [dashboardId]="selectedDashboard?.id"
  ></app-resources-lvl2-table>

  <app-interested-per-hour-matrix
    *ngIf="card.node.card.type === 'INTERESTED_PER_HOUR_MATRIX' && selectedDashboard?.id"
    [dashboardTitle]="card.node.card.title"
    [dashboardId]="selectedDashboard?.id"
    [card]='card?.node?.card'
  ></app-interested-per-hour-matrix>
</div>
